import { render, staticRenderFns } from "./google-auth.vue?vue&type=template&id=c897b03a&scoped=true&"
import script from "./google-auth.vue?vue&type=script&lang=js&"
export * from "./google-auth.vue?vue&type=script&lang=js&"
import style0 from "./google-auth.vue?vue&type=style&index=0&id=c897b03a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c897b03a",
  null
  
)

export default component.exports